<script lang="ts">
  let {
    bankAccount = $bindable(),
    errors
  }: {
    bankAccount: { [key: string]: string };
    errors: { [key: string]: string } | null;
  } = $props();
</script>

<fieldset class="ui-fieldset">
  <legend>Bank Name</legend>
  <input
    type="text"
    name="bank_provider"
    class="ui-input"
    class:border-error={errors?.bank_provider}
    bind:value={bankAccount.bankProvider}
    required
  />
  {#if errors?.bank_provider}
    <div class="ui-error">{errors?.bank_provider}</div>
  {/if}
</fieldset>

<fieldset class="ui-fieldset">
  <legend>Account Holder Name</legend>
  <input
    type="text"
    name="account_holder_name"
    class="ui-input"
    class:border-error={errors?.account_holder_name}
    bind:value={bankAccount.accountHolderName}
    required
  />
  {#if errors?.account_holder_name}
    <div class="ui-error">{errors?.account_holder_name}</div>
  {/if}
</fieldset>

<fieldset class="ui-fieldset">
  <legend>Sort Code</legend>
  <input
    type="text"
    name="sort_code"
    class="ui-input"
    class:border-error={errors?.sort_code}
    bind:value={bankAccount.sortCode}
    required
    inputmode="numeric"
    pattern={"[0-9]{6}"}
    title="6-digit number"
  />
  {#if errors?.sort_code}
    <div class="ui-error">{errors?.sort_code}</div>
  {/if}
</fieldset>

<fieldset class="ui-fieldset">
  <legend>Account Number</legend>
  <input
    type="text"
    name="account_number"
    class="ui-input"
    class:border-error={errors?.account_number}
    bind:value={bankAccount.accountNumber}
    required
    inputmode="numeric"
    pattern="\d+"
    title="numeric"
  />
  {#if errors?.account_number}
    <div class="ui-error">{errors?.account_number}</div>
  {/if}
</fieldset>

